export default __webpack_public_path__ + "static/media/ASSETS-14.71bceea3.png";